import potionSound from '../../assets/audio/GP_Heal_1.wav';
import gold1Sound from '../../assets/audio/Pickup_Gold_00.wav';
import gold2Sound from '../../assets/audio/Pickup_Gold_01.wav';
import startRunSound from '../../assets/audio/Jingle_Achievement_00.wav';

import locationChange1Sound from '../../assets/audio/Footstep_Dirt_02.wav';
import locationChange2Sound from '../../assets/audio/Footstep_Dirt_03.wav';
import locationChange3Sound from '../../assets/audio/Footstep_Dirt_04.wav';
import locationChange4Sound from '../../assets/audio/Footstep_Dirt_05.wav';

import pickupPotionSound from '../../assets/audio/Inventory_Open_00.wav';
import restSound from '../../assets/audio/male-sigh-6763.mp3';





import { Button, Col, Row, Typography } from 'antd';
import { random } from 'lodash';
import { FC, useCallback } from 'react';

import { LocationType } from '../locations/location.generators';
import { useAreAllEnemiesDead } from '../store/game.hooks';
import { useEnemyStore, useGameStore, useHeroStore, useLocationStore, useShopStore } from '../store/game.store';
import { EnemyCard } from './EnemyCard';

interface LevelProps extends React.PropsWithChildren { }
export const Level: FC<LevelProps> = () => {
   const { state: locationState, actions: locationActions } = useLocationStore();
   const { state: enemyState } = useEnemyStore();
   const { gameActions } = useGameStore();
   const areAllEnemiesDead = useAreAllEnemiesDead();
   const { actions: heroActions, state: heroState } = useHeroStore();
   const { actions: shopActions } = useShopStore();

   function playSoundsSequentially() {
      let index = 0;
      const sounds = [
         locationChange1Sound,
         locationChange2Sound,
         locationChange3Sound,
         locationChange4Sound];

      function playNextSound() {
         if (index < sounds.length) {
            const audio = new Audio(sounds[index]);
            audio.play();
            audio.onended = playNextSound;
            index++;
         }
      }
      playNextSound();
   }

   const handleStartNewRun = useCallback(() => {
      gameActions.navigateToRandomLocation();
      new Audio(startRunSound).play();
   }, [heroActions.heroicActions, locationActions]);

   const handleEnvNavigation = useCallback(() => {
      playSoundsSequentially();
      heroActions.heroicActions.attemptToNavigateSafely(locationState.currentLocation);
      locationActions.setLocationCompleted();
   }, [heroActions.heroicActions, locationActions, locationState.currentLocation]);

   const handleVentureForth = useCallback(() => {
      playSoundsSequentially();
      gameActions.navigateToRandomLocation();
   }, [gameActions]);

   const handleRest = useCallback(() => {
      new Audio(restSound).play();
      heroActions.heroicActions.recoverHealth(5);
      locationActions.setLocationCompleted();
   }, [heroActions.heroicActions, locationActions]);

   const handleFindGold = useCallback(() => {
      new Audio(gold1Sound).play();
      new Audio(gold2Sound).play();
      const randomGoldAmount = random(4, 15);
      shopActions.addGold(randomGoldAmount);
      locationActions.setLocationCompleted();
   }, [locationActions, shopActions]);

   const handleKeepPotion = useCallback(() => {
      new Audio(pickupPotionSound).play();
      heroActions.heroicActions.pickUpPotion();
      locationActions.setLocationCompleted();
   }, [heroActions.heroicActions, locationActions]);

   const handleDrinkPotion = useCallback(() => {
      new Audio(potionSound).play();
      heroActions.heroicActions.recoverHealth(10);
      locationActions.setLocationCompleted();
   }, [heroActions.heroicActions, locationActions]);

   return (

      <div className="p-1">



         {/* Location background image */}
         <div
            className="levelImageBox levelImageBox2 levelBorder"
            style={{ backgroundImage: `url(${locationState.currentLocation.imageFilePath})` }}>
         </div>

         {/* Location Title */}
         <Typography.Title level={5} className="!text-black p-1 items-center justify-center text-center">
            <span>{locationState.currentLocation.name}</span>
         </Typography.Title>


         {/* Enemies */}
         <div className="flex items-center justify-center p-1">
            {/* display all the enemy cards if there are any enemies in the enemy slice */}
            <div className="grid grid-cols-2 gap-1 mb-1">
               {Object.values(enemyState.enemies).map((enemy) => (
                  <EnemyCard
                     key={enemy.id}
                     id={enemy.id}
                     className="bg-white p-1"
                     imageClassName="h-24 object-scale-down" // Reduced height
                  />
               ))}
            </div>
         </div>



         {/* Iteractions based on the location type */}
         <div className="flex flex-1 justify-center items-center">
            <div className="text-center">
               {locationState.currentLocation.name === 'Cragknoll Village' && (
                  <div className="!text-black ">
                     <p className="intro-top-pair">A dozen generations long passed since last it flew,</p>
                     <p className="intro-bottom-pair">A call put out to summon all heroes both old and new,</p>

                     <p className="intro-top-pair">Lost relics must be recovered - insist ancient wisdom bound,</p>
                     <p className="intro-bottom-pair">Quests filled with perils must be overcome before they are found,</p>

                     <p className="intro-top-pair">Evil arises from every corner and inflicts a heavy toll,</p>
                     <p className="intro-bottom-pair">The power to save - rests in the village of Cragknoll,</p>

                     <p className="intro-top-pair">The heroes will need every skill and weapon they can get,</p>
                     <p className="intro-bottom-pair">This adventure will be one the bards do not forget!</p>

                     <Button
                        type="primary"
                        onClick={handleStartNewRun}
                     >
                        Begin journey!
                     </Button>
                  </div>
               )}

               {locationState.currentLocation.locationType === LocationType.Rest && locationState.currentLocation.name !== 'Cragknoll Village' && !locationState.currentLocation.completed && <Button onClick={handleRest}>Rest</Button>}

               {locationState.currentLocation.locationType === LocationType.FindGold && !locationState.currentLocation.completed && <Button onClick={handleFindGold}>You found some gold!</Button>}

               {locationState.currentLocation.locationType === LocationType.EnvironmentRisk && !locationState.currentLocation.completed && <Button onClick={handleEnvNavigation}>Try to find a safe way forward!</Button>}

               {locationState.currentLocation.locationType === LocationType.FindPotion && !locationState.currentLocation.completed && (
                  <div>
                     <Typography.Title
                        level={4}
                        className="!text-black drop-shadow-xl"
                     >
                        You found a potion!
                     </Typography.Title>
                     <Button
                        type="primary"
                        onClick={handleKeepPotion}
                        disabled={heroState.potionAvailable === heroState.potionMaxCapacity}
                     >
                        Keep it
                     </Button>
                     <Button
                        type="primary"
                        onClick={handleDrinkPotion}
                     >
                        Drink it
                     </Button>
                  </div>
               )}
            </div>


         </div>

         {/* the container for the actions at the bottom of the page */}
         <div className="text-center space-y-4">
            {/* if the current level is a gobbo attack and all the enemies are dead, hooray! */}
            {(locationState.currentLocation.locationType === LocationType.GobboAttack || locationState.currentLocation.locationType === LocationType.BanditAttack || locationState.currentLocation.locationType === LocationType.BossAttack) &&
               areAllEnemiesDead && <div>{!locationState.currentLocation.completed && <Button onClick={handleFindGold}>Pickup gold</Button>}</div>}
            {locationState.currentLocation.completed && (
               <Button
                  type="primary"
                  onClick={handleVentureForth}
               >
                  Venture forth!
               </Button>
            )}
         </div>




      </div >
   );
};
